import { IntegrityMonitorSectionState } from './integrity-monitor.types';
import { DataLoadedStatus, SectionStatusType } from '../../types';

export const defaultIntegrityMonitorRealTimeState: IntegrityMonitorSectionState = {
  isValid: true,
  status: { type: SectionStatusType.NONE },
  additionalInfo: {
    companyRuleSetsLoaded: DataLoadedStatus.NOT_LOADED,
    selectedRuleSetsLoaded: DataLoadedStatus.NOT_LOADED,
  },
};
